import { createSelector } from 'reselect'

const getBoardId = (state, props) => {
  return props.boardContext.id
}

const getUserIds = (state, props) => {
  return state['view-board'].users[props.boardContext.id].users
}

const getUsersById = (state, props) => {
  return state['view-board'].users[props.boardContext.id].usersById
}

const getKanBoUsers = (state, props) => {
  return state.kanbo.users
}

const getOnlyActive = (state, props) => {
  return props.onlyActive
}

const getCurrentUserId = (state, props) => {
  return state.kanbo.currentUser.id
}

const makeUsersSelector = () => createSelector(
  [
    getUserIds,
    getUsersById,
    getKanBoUsers,
    getOnlyActive,
    getCurrentUserId
  ],
  (
    userIds,
    usersById,
    kanBoUsers,
    onlyActive,
    currentUserId
  ) => {
    const output = usersById[currentUserId] ? [{
      ...usersById[currentUserId],
      ...kanBoUsers[currentUserId]
    }] : []

    const sortedUsers = userIds
      .map(id => (
        {
          ...usersById[id],
          ...(kanBoUsers[id] || { id, isActive: true })
        }
      ))
      .filter(user =>
        user.id !== currentUserId &&
        (!onlyActive || user.isActive)
      )
      .sort((a, b) => {
        if (a.permissionLevel === b.permissionLevel) {
          return a.id - b.id
        } else {
          return b.permissionLevel - a.permissionLevel
        }
      })

    return output.concat(sortedUsers)
  }
)

const getCursor = (state, props) => {
  return state['view-board'].users[props.boardContext.id].cursor
}

const getOnlyActiveCursor = (state, props) => {
  return state['view-board'].users[props.boardContext.id].onlyActiveCursor
}

const getLoading = (state, props) => {
  return state['view-board'].users[props.boardContext.id].loading
}

const getLoaded = (state, props) => {
  return state['view-board'].users[props.boardContext.id].loaded
}

const getOnlyActiveLoading = (state, props) => {
  return state['view-board'].users[props.boardContext.id].onlyActiveLoading
}

const getOnlyActiveLoaded = (state, props) => {
  return state['view-board'].users[props.boardContext.id].onlyActiveLoaded
}

export default () => {
  const usersSelector = makeUsersSelector()

  return createSelector(
    [
      getBoardId,
      usersSelector,
      getCursor,
      getOnlyActiveCursor,
      getLoading,
      getLoaded,
      getOnlyActiveLoading,
      getOnlyActiveLoaded
    ],
    (
      boardId,
      users,
      cursor,
      onlyActiveCursor,
      loading,
      loaded,
      onlyActiveLoading,
      onlyActiveLoaded
    ) => ({
      boardId,
      users,
      cursor,
      onlyActiveCursor,
      loading,
      loaded,
      onlyActiveLoading,
      onlyActiveLoaded
    })
  )
}
